// Single authoritative source for MySiteCare's verified legal business identity —
// sourced from the actual DTI Business Name Registration and BIR Certificate of
// Registration documents. Every public page, copyright notice, or attribution that
// needs to state the business's legal identity should import from here rather than
// retyping these values — see /legal/BUSINESS-IDENTITY.md for the same information in
// document form, and reports/mysitecare-production-emergent-handoff.md for how this
// was verified.
//
// Deliberately excluded, by design, regardless of how this object is used elsewhere:
// TIN, BIR/ORUS/eFPS login credentials, payment references, personal phone/email,
// date of birth, government ID numbers, or other sensitive information. The registered
// business address below was supplied for public display from current official records.
// remains protected inside the existing private, encrypted BIR/tax admin system
// (see backend/billing_routes.py's tax profile endpoints) — it is never duplicated
// here or anywhere public.
export const legalBusinessIdentity = {
  proprietor: "Jeanjen Sisoy Luberio",

  businessName: "MySiteCare Website Application Services",
  formalBusinessName: "MYSITECARE WEBSITE APPLICATION SERVICES",
  registeredBusinessAddress: "Tampocon II, 6210 Ayungon, Negros Oriental, Philippines",

  businessType: "Single Proprietorship",
  jurisdiction: "Republic of the Philippines",

  dti: {
    businessNameNumber: "7934250",
    territorialScope: "City / Municipality",
    registeredFrom: "2026-02-15",
    registeredUntil: "2031-02-15",
  },

  bir: {
    registered: true,
    registrationDate: "2026-08-28",
    lineOfBusiness: "WEBSITE APPLICATION SERVICES",
    publicVerificationMethod: "BIR Registration Seal Badge",
  },

  website: "https://mysitecare.eu",
};
